import * as Sentry from '@sentry/browser';

import { API_BASE_URL, API_COMPANY_ID } from '../constants';

const makeApiRequest = async (url, data, method = 'POST', returnErrors = false) => {
  const response = await fetch(`${API_BASE_URL}${url}`, {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      companyId: API_COMPANY_ID,
      userID: 1,
      ...data,
    }),
  });

  const responseData = await response.json();

  // If we want to return the error response
  if (returnErrors) {
    return responseData;
  }

  if (!response.ok) {
    console.error(responseData);
    // console.error(responseData.error);
    Sentry.addBreadcrumb({
      category: 'api',
      message: `Request sent to ${url}`,
      data: JSON.stringify({ paylod: data, responseData }, null, 2),
    });
    throw new Error(`${url} | ${responseData.message} | ${JSON.stringify(responseData.error)}`);
  }

  return responseData.data ?? responseData;
};

export default makeApiRequest;
